lmApp.service('AssetResource', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/assets',
    null,
      {
        get: {
          params: {},
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          },
          isArray: true,
          transformResponse: function (data) {
            var result = angular.fromJson(data);
            if (result && result.data) return result.data;
            return [];
          }
        },
        count: {
          url: '/discovery:80/sdp/v2/assets/$count',
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        getStream: {
          url: '/discovery:80/sdp/v2/assets/:id/resources/:resourceId/url',
          method: 'GET',
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
            'X-Instance-Check': ''
          },
          params: {
            id: '@id',
            resourceId: '@resourceId'
          }
        },
        create: {
          method: 'POST',
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        update: {
          url: '/discovery:80/sdp/v2/assets/:id',
          method: 'PATCH',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        remove: {
          url: '/discovery:80/sdp/v2/assets/:id',
          method: 'DELETE',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        getPackageAssets: {
          params: {
            id: '@id'
          },
          url: '/discovery:80/sdp/v2/assets/:id/package-assets',
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          },
          isArray: true,
          transformResponse: function (data) {
            var result = angular.fromJson(data);
            if (result && result.data) return result.data;
            return [];
          }
        },
        setPackageAssets: {
          url: '/discovery:80/sdp/v2/assets/:id/package-assets',
          method: 'PUT',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        createSeason: {
          url: '/discovery:80/sdp/v2/assets/:id/series-seasons',
          method: 'POST',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        createEpisode: {
          url: '/discovery:80/sdp/v2/assets/:id/season-episodes',
          method: 'POST',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
      }
  );
}]);
